import * as React from 'react';
import { Eye, EyeOff } from 'lucide-react';

import { Button } from 'src/components/ui/button';
import { cn } from 'src/lib/utils';

const Input = ({ className, type, ...props }: React.ComponentProps<'input'>) => {
  return (
    <input
      type={type}
      className={cn(
        'flex h-10 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-input-placeholder placeholder:font-light focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-secondary disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:focus-visible:ring-destructive',
        className,
      )}
      {...props}
    />
  );
};

const InputPassword = ({ className, ...props }: React.ComponentProps<'input'>) => {
  const [showPassword, setShowPassword] = React.useState(false);

  const Icon = showPassword ? EyeOff : Eye;

  const handleClick = () => setShowPassword((prev) => !prev);

  return (
    <div className="relative">
      <Input type={showPassword ? 'text' : 'password'} className={cn(className)} {...props} />
      <Button type="button" variant="ghost" size="icon" className="absolute right-0 top-0.5" onClick={handleClick}>
        <Icon className="size-4" />
      </Button>
    </div>
  );
};

export { Input, InputPassword };
